export default class Language {
  static COLUMN_PREFIX = 'customValue_';

  id: number = null;
  isoLanguageName: string = null;
  isoCode: string = null;
  nativeName: string = null;
  isNotPrimary: boolean = null;
  primaryLabel: string = null;

  constructor(language?: Language) {
    Object.assign(this, language);
  }

  get dynamicName() {
    return Language.COLUMN_PREFIX + this.id;
  }

  get systemPlusNativeName() {
    return `${this.isoLanguageName} (${this.nativeName})`;
  }

  set systemPlusNativeName(value) {}
}
